"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Incentives = void 0;
var Incentives;
(function (Incentives) {
    Incentives["BESTFIT_SEARCH"] = "bestfit_search";
    Incentives["GLOBAL_ACCESS_INITIATIVE_BANNER"] = "global_access_initiative_banner";
    Incentives["GLOBAL_ACCESS_INITIATIVE_LABEL"] = "global_access_initiative_label";
    Incentives["SEARCH_GLOBAL_ACCESS_INITIATIVE_LABEL"] = "search_global_access_initiative_label";
    Incentives["SCHOLARSHIP_INCENTIVE_LABEL"] = "scholarship_incentive_label";
    Incentives["SEARCH_SCHOLARSHIP_INCENTIVE_LABEL"] = "search_scholarship_incentive_label";
    Incentives["ONBOARDING_NOTIFICATIONS_INCENTIVE"] = "onboarding_notifications_incentive";
    Incentives["ONBOARDING_INCENTIVE"] = "onboarding_incentive";
    Incentives["LOCALIZATION_SETTINGS_INCENTIVE"] = "localization_settings_incentive";
})(Incentives || (exports.Incentives = Incentives = {}));
